// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as RescriptRelay from "rescript-relay/src/RescriptRelay.re.mjs";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as RescriptRelayReact from "rescript-relay/src/RescriptRelayReact.re.mjs";

function makeRefetchVariables() {
  
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

function convertVariables(value) {
  return RescriptRelay.convertWithoutPlan(value, undefined);
}

let wrapResponseConverter = {"roots":{"__root":[{"fragments":true,"path":[]}]},"version":2};

let preparedWrapResponseConverter = RescriptRelay.prepareConversion(wrapResponseConverter, undefined, null);

function convertWrapResponse(value) {
  return RescriptRelay.runConversion(preparedWrapResponseConverter, value);
}

let preparedResponseConverter = RescriptRelay.prepareConversion(wrapResponseConverter, undefined, undefined);

function convertResponse(value) {
  return RescriptRelay.runConversion(preparedResponseConverter, value);
}

let Internal = {
  convertVariables: convertVariables,
  convertWrapResponse: convertWrapResponse,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sku",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  (v2/*: any*/)
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HomePageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HomeFeaturedProducts_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HomeReviews_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HomeAmericanOrders_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HomeFeaturedArtists_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HomePageQuery",
    "selections": [
      {
        "alias": "custphotoreal",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "sku",
            "value": "custphotoreal"
          }
        ],
        "concreteType": "GalleryItem",
        "kind": "LinkedField",
        "name": "featuredOrdersBySku",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "featuredOrdersBySku(first:6,sku:\"custphotoreal\")"
      },
      {
        "alias": "custwatercolor",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "sku",
            "value": "custwatercolor"
          }
        ],
        "concreteType": "GalleryItem",
        "kind": "LinkedField",
        "name": "featuredOrdersBySku",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "featuredOrdersBySku(first:6,sku:\"custwatercolor\")"
      },
      {
        "alias": "custcharcoal",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "sku",
            "value": "custcharcoal"
          }
        ],
        "concreteType": "GalleryItem",
        "kind": "LinkedField",
        "name": "featuredOrdersBySku",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "featuredOrdersBySku(first:6,sku:\"custcharcoal\")"
      },
      {
        "alias": "custpencil",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "sku",
            "value": "custpencil"
          }
        ],
        "concreteType": "GalleryItem",
        "kind": "LinkedField",
        "name": "featuredOrdersBySku",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "featuredOrdersBySku(first:6,sku:\"custpencil\")"
      },
      {
        "alias": "custcoloredpencil",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "sku",
            "value": "custcoloredpencil"
          }
        ],
        "concreteType": "GalleryItem",
        "kind": "LinkedField",
        "name": "featuredOrdersBySku",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "featuredOrdersBySku(first:6,sku:\"custcoloredpencil\")"
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Review",
        "kind": "LinkedField",
        "name": "featuredReviews",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orderId",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reviewerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reviewDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "image",
            "storageKey": null
          }
        ],
        "storageKey": "featuredReviews(first:4)"
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalReviewsCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          }
        ],
        "concreteType": "GalleryItem",
        "kind": "LinkedField",
        "name": "americanOrders",
        "plural": true,
        "selections": (v3/*: any*/),
        "storageKey": "americanOrders(first:5)"
      },
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "FeaturedSupplier",
        "kind": "LinkedField",
        "name": "featuredArtists",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sampleImage",
            "storageKey": null
          }
        ],
        "storageKey": "featuredArtists(first:4)"
      }
    ]
  },
  "params": {
    "cacheID": "b4a9ef803a7f1f9e6c648840fd4f17ac",
    "id": null,
    "metadata": {},
    "name": "HomePageQuery",
    "operationKind": "query",
    "text": "query HomePageQuery {\n  ...HomeFeaturedProducts_query\n  ...HomeReviews_query\n  ...HomeAmericanOrders_query\n  ...HomeFeaturedArtists_query\n}\n\nfragment HomeAmericanOrders_query on Query {\n  americanOrders(first: 5) {\n    id\n    url\n    sku\n  }\n}\n\nfragment HomeFeaturedArtists_query on Query {\n  featuredArtists(first: 4) {\n    id\n    username\n    displayName\n    name\n    country\n    sampleImage\n  }\n}\n\nfragment HomeFeaturedProducts_query on Query {\n  custphotoreal: featuredOrdersBySku(sku: \"custphotoreal\", first: 6) {\n    id\n    url\n    sku\n  }\n  custwatercolor: featuredOrdersBySku(sku: \"custwatercolor\", first: 6) {\n    id\n    url\n    sku\n  }\n  custcharcoal: featuredOrdersBySku(sku: \"custcharcoal\", first: 6) {\n    id\n    url\n    sku\n  }\n  custpencil: featuredOrdersBySku(sku: \"custpencil\", first: 6) {\n    id\n    url\n    sku\n  }\n  custcoloredpencil: featuredOrdersBySku(sku: \"custcoloredpencil\", first: 6) {\n    id\n    url\n    sku\n  }\n}\n\nfragment HomeReviews_query on Query {\n  featuredReviews(first: 4) {\n    orderId\n    sku\n    rating\n    text\n    reviewerName\n    city\n    country\n    reviewDate\n    image\n  }\n  totalReviewsCount\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return RescriptRelayReact.loadQuery(environment, node, RescriptRelay.convertWithoutPlan(variables, undefined), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

export {
  Types,
  Internal,
  Utils,
  node,
  load,
  queryRefToObservable,
  queryRefToPromise,
}
/* preparedWrapResponseConverter Not a pure module */
